/* B237 — show Trending Halloween chips only for focused empty searches. */
(function(){
  function init(root){
    if(!root || root.dataset.dhcTrendingInit==='1') return;
    var input=root.querySelector('[data-dhc-search-input]');
    var panel=root.querySelector('[data-dhc-search-trending]');
    if(!input || !panel) return;
    root.dataset.dhcTrendingInit='1';
    function sync(){
      var active=(document.activeElement===input || root.matches(':focus-within')) && !input.value.trim();
      panel.hidden=!active;
      root.classList.toggle('dhc-trending-open',active);
    }
    input.addEventListener('focus',sync);
    input.addEventListener('input',sync);
    input.addEventListener('search',sync);
    root.addEventListener('focusout',function(){setTimeout(sync,0);});
    document.addEventListener('pointerdown',function(e){if(!root.contains(e.target)){panel.hidden=true;root.classList.remove('dhc-trending-open');}});
    sync();
  }
  function boot(){document.querySelectorAll('[data-dhc-search-wrap]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
